import { connect } from 'react-redux';
import Price from './Price';

export default connect(
  ({ order, product, settings }) => ({
    settings,
    bodyStyles: settings.style.body,
    depositAllowed: product.data.deposit_allowed,
    paymentOption: order.paymentOption,
    totalPrice: +order.totalPrice || 0,
    totalQuantity: order.totalQuantity || 1,
  })
)(Price);
